import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { toast } from "react-toastify";
import { ToastErrorTile } from "uikit/components";

export default function FormikToastOnError({ title, text, children }) {
    const { isValid, isSubmitting } = useFormikContext();

    useEffect(() => {
        if (isSubmitting && !isValid) {
            toast.error(<ToastErrorTile title={title} text={text} />);
        }
    }, [isSubmitting, isValid, text, title]);

    return children;
}

FormikToastOnError.propTypes = {
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};
